"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCorrelationId = void 0;
const generateCorrelationId = (prefix, uniqueIdGenerator) => `${prefix}${uniqueIdGenerator().substring(0, 7)}`;
exports.generateCorrelationId = generateCorrelationId;
//# sourceMappingURL=generate-correlation-id.js.map